module.exports = __webpack_public_path__ + "img/jingzhuang8.c41ce5b0.jpg";